import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'

export const SectionWrapper = styled.div`
  &::-webkit-scrollbar {
    display: '';
  }
`
export const SectionItem = styled.div`
  margin-bottom: 1rem;
  width: 100%;
`
export const FlexWraper = styled(Flex)`
  justify-content: space-between;
  line-height: 1.3rem;
`
export const BoldText = styled.div`
  font-weight: 700;
  font-size: 1.1rem;
`
export const LightText = styled.div`
  font-weight: 500;
  font-size: 0.7rem;
`
export const InfoSection = styled(Flex)`
  margin-left: 10px;
  flex-direction: column;
  width: 100%;
`
export const InfoItem = styled(Flex)`
  justify-content: space-between;
  margin-bottom: 1rem;
`
export const TitleName = styled.div`
  line-height: 1.3rem;
`
export const ListWraper = styled(Flex)`
  align-items: flex-start;
  margin-top: 1rem;
`
export const BottomData = styled.div`
  font-size: 0.937rem;
  color: ${COLORS.GREY_T_30};
  font-weight: 400;
  line-height: 20px;
  text-transform: lowercase;
  &::first-letter {
    text-transform: capitalize;
  }
`
export const BottomInfo = styled(Flex)`
  gap: 0.5rem;
`
export const Wrapper = styled.div`
  height: 70vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`
